module.exports = __webpack_public_path__ + "img/avatar-default.63573f8b.svg";